<template>
  <TsSection class="md:mt-6 mt-4">
    <TsTypography append-class="mb-4 line-clamp-2" weight="normal" as="h2"
    >{{ useTranslation('couldntFindMatch', 'Het lijkt erop dat we geen match voor konden vinden') }}
      <strong class="font-bold">“{{ searchResultStore.searchResultState.message }}”</strong></TsTypography
    >
    <TsTypography append-class="mb-4 " size="sm"
    >{{ useTranslation('tryAgainOrBrowse', 'Probeer het opnieuw of blader door onze categorie') }}</TsTypography
    >

    <TsImage
        width="160"
        class="text-center mx-auto"
        src="/images/searchResultNotFound.svg"
    />
    <div class="mt-8">
      <TsContent model="symbol" path="/symbol/card-link" />
    </div>
  </TsSection>
</template>
<script setup lang="ts">

const searchResultStore = useSearchResultStore();

type Props = {
  metaTitle?: string
}

const props = withDefaults(defineProps<Props>(), {
  metaTitle: () => useCapitalize(useTranslation('toSearch', 'Zoeken'))
})

useHead({
  title: () => props.metaTitle,
  meta: [{ name: "description", content: "search result" }],
});

const products = ref({
  breakpoints: {
    0: {
      itemsToShow: 2.1,
      snapAlign: "start",
    },
    640: {
      itemsToShow: 4,
      snapAlign: "start",
    },
    1024: {
      itemsToShow: 5,
      snapAlign: "center",
    },
  },
  data: [],
});

onMounted(async () => {
  try {
    const { default: defaultProducts } = await import('~/json/products-dummy.json');
    products.value.data = defaultProducts;
    console.log('Products loaded:', products.value.data);
  } catch (error) {
    console.error("Failed to load default products:", error);
  }
});
</script>
